import authSlice from 'redux/slices/authSlice';
import tokenSlice from 'redux/slices/tokenSlice';
import dataSlice from 'redux/slices/dataSlice';
import filesSlice from 'redux/slices/filesSlice';
import modalSlice from 'redux/slices/modalSlice';
import notificationSlice from 'redux/slices/notificationSlice';

const rootReducer = {
  auth: authSlice.reducer,
  token: tokenSlice.reducer,
  data: dataSlice.reducer,
  files: filesSlice.reducer,
  modal: modalSlice.reducer,
  notifications: notificationSlice.reducer,
};

export default rootReducer;

export const ACTIONS = {
  auth: { ...authSlice.actions },
  data: { ...dataSlice.actions },
  files: { ...filesSlice.actions },
  modal: { ...modalSlice.actions },
  notification: { ...notificationSlice.actions },
};
